<template>
  <div>
    <BaseErrors :errors="errors"></BaseErrors>
    <form action="">
      <div class="row">
        <div class="form-group col-6">
          <label for="sg-input" class="form-label">SG</label>
          <input v-model="sg" type="number" step="0.001" min="0.900" max="1.150" class="form-control" name="sg"
                 id="sg-input">
        </div>

        <div class="form-group col-6">
          <label for="temp-input" class="form-label">Temp ({{ temperatureUnit() }})</label>
          <input v-model="temp" type="number" step="0.1" min="-5" max="35" class="form-control" name="temp"
                 id="temp-input">
        </div>
      </div>
      <div class="row">

        <div class="form-group col-6">
          <label for="datetime-input" class="form-label">Timestamp</label>
          <input v-model="timestamp" type="datetime-local" class="form-control" name="timestamp" id="datetime-input">
        </div>

        <div class="form-group col-6">
          <label for="stream-select">Source</label>
          <select v-model="streamId" class="form-control" id="stream-select">
            <option value="">Select Stream</option>
            <option v-for="stream in streams"
                    :value="stream.id">
              {{ stream.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-6">
          <label for="comment-input" class="form-label">Comment</label>
          <input v-model="comment" type="text" class="form-control" name="comment" id="comment-input">
        </div>
      </div>
    </form>


    <button type="submit" :disabled="loading" v-on:click.prevent="pushBrewRecord()" class="btn btn-primary btn-sm">
      <span v-if="!loading">Push</span>
      <span v-if="loading">Pushing...</span>
    </button>

  </div>
</template>


<script>
import {EventBus} from '@/lib/event-bus.js';
import BaseErrors from "@/components/bits/BaseErrors";
import {HTTP} from '@/lib/http';

export default {
  name: 'brew-records-push',
  props: {
    brewSessionId: Number
  },
  components: {
    BaseErrors
  },
  data() {
    return {
      errors: null,
      loading: true,
      streams: null,
      streamId: null,
      sg: null,
      temp: null,
      timestamp: null,
      comment: null
    }
  },
  methods: {
    fetchStreams() {
      HTTP.get("streams")
        .then(response => {
          this.streams = response.data.data;
          if (this.streams.length) {
            this.streamId = _(this.streams).first().id
          }
        })
        .catch(err => {
          this.errors = [err.response.data.message];
        })
        .then(() => {
          this.loading = false;
        });
    },
    pushBrewRecord() {
      HTTP.post(`brew-sessions/${this.brewSessionId}/add-stream-record`,
        {
          data: {
            "sg": this.sg,
            "temperature": `${this.temp} ${this.temperatureUnit()}`,
            "created_at": this.timestamp,
            "comment": this.comment,
            "stream_id": this.streamId,
          }
        }
      )
        .then(response => {
          EventBus.$emit(`brew-session-data-changed:${this.brewSessionId}`, true)
        })
        .catch(err => {
          this.errors = [err.response.data.message];
        })
        .then(() => {
          this.loading = false;
        });
    }
  },
  beforeMount() {
    this.fetchStreams();
  },
}
</script>

<style scoped lang="scss">
@import "/../assets/scss/_variablesx.scss";

.row {
  margin-left: 15px;
  margin-right: 15px;
}
</style>
